module.exports = __webpack_public_path__ + "img/img-header.581b493.webp";